import React, { useState } from 'react'
import type { InjuryInfo } from '../types'

interface InjuryListProps {
  injuries: InjuryInfo[]
  teamName: string
  collapsed?: boolean
}

export function InjuryList({ injuries, teamName, collapsed = true }: InjuryListProps) {
  const [isExpanded, setIsExpanded] = useState(!collapsed)

  if (!injuries || injuries.length === 0) return null

  const outCount = injuries.filter((i) => i.status === 'out').length
  const doubtfulCount = injuries.filter((i) => i.status === 'doubtful').length

  return (
    <div className="injury-list">
      <button
        className="injury-list-header"
        onClick={() => setIsExpanded(!isExpanded)}
        type="button"
      >
        <span className="injury-list-title">
          Injuries ({injuries.length})
          {outCount > 0 && (
            <span className="injury-count injury-count-out">{outCount} out</span>
          )}
          {doubtfulCount > 0 && (
            <span className="injury-count injury-count-doubtful">{doubtfulCount} doubtful</span>
          )}
        </span>
        <span className={`injury-list-chevron ${isExpanded ? 'expanded' : ''}`}>
          {isExpanded ? '▼' : '▶'}
        </span>
      </button>

      {isExpanded && (
        <div className="injury-list-items">
          {injuries.map((injury) => (
            <div key={injury.player_id} className="injury-item">
              <div className="injury-item-player">
                <span className="injury-item-name">{injury.player_name}</span>
                {injury.position && (
                  <span className="injury-item-position">{injury.position}</span>
                )}
              </div>
              <div className="injury-item-details">
                <span className={`injury-item-status injury-status-${injury.status}`}>
                  {injury.status === 'out' ? 'OUT' : 'DOUBT'}
                </span>
                <span className="injury-item-type">{injury.injury_type}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
